<template>
  <div class="lee-slide-check"
       :style="{fontSize:fontSize+'px',width:width+'px',lineHeight:height+'px',height:height+'px',width:width+'px'}">
    <div class="slide-bg" :style="{transition:'all '+ms+' ease-out',width:moveX+'px',background:bgColor}"></div>
    <div class="slide-text">
      <template v-if="!isOk">拖动滑块验证</template>
      <template v-else><i class="b">验证通过</i></template>
    </div>
    <div class="handle" :class="{ok:isOk}" ref="handle" :style="{transition:'all '+ms+' ease-out',left:moveX+'px'}"
         @mousedown.prevent="mouseDown" @mousemove.prevent="mouseMove" @mouseup.prevent="mouseUp"
         @touchstart.stop="touchStart" @touchmove.stop="touchMove" @touchend.stop="touchEnd"></div>
  </div>
</template>
<script>
export default {
    name: 'LeeSlideCheck',
    inheritAttrs: false,
    data() {
        return {
            moveX: 0,
            isOk: false,
            isDown: false,
            oldX: 0,
            ms: '0s'
        }
    },
    mounted() {
        document.addEventListener('mousedown', (e) => {
            this.oldX = e.pageX
            this.isDown = true
        })
        document.addEventListener('mousemove', (e) => {
            e.stopPropagation()
            if (this.isDown) {
                let target = this.$refs.handle
                this.moveX = e.pageX - this.oldX
                if (this.moveX <= 0) {
                    this.moveX = 0
                }
                if (this.moveX >= this.width - target.getBoundingClientRect().width) {
                    this.moveX = this.width - target.getBoundingClientRect().width
                    this.isOk = true
                }

            }


        })
        document.addEventListener('mouseup', () => {
            this.isDown = false
        })
    },
    methods: {
        mouseDown(e) {
            this.oldX = e.pageX
            this.isDown = true
        },
        mouseMove(e) {
            if (this.isDown) {
                let target = e.currentTarget
                this.moveX = e.pageX - this.oldX
                if (this.moveX <= 0) {
                    this.moveX = 0
                }
                if (this.moveX >= this.width - target.getBoundingClientRect().width) {
                    this.moveX = this.width - target.getBoundingClientRect().width
                    this.isOk = true
                }

            }
        },
        mouseUp() {
            this.isDown = false
        },
        touchStart(e) {
            this.oldX = e.targetTouches[0].pageX
            this.isDown = true
        },
        touchMove(e) {
            if (this.isDown) {
                let target = e.currentTarget
                this.moveX = e.targetTouches[0].pageX - this.oldX
                if (this.moveX <= 0) {
                    this.moveX = 0
                }
                if (this.moveX >= this.width - target.getBoundingClientRect().width) {
                    this.moveX = this.width - target.getBoundingClientRect().width
                    this.isOk = true
                }

            }
        },
        touchEnd() {
            this.isDown = false
        },
    },
    props: {
        fontSize: {
            type: Number,
            default: 12
        },
        width: {
            type: Number,
            default: 300
        },
        height: {
            type: Number,
            default: 34
        },
        bgColor: {
            type: String,
            default: '#7ac23c'
        }
    },
    watch: {
        isDown: {
            immediate: false,
            handler(value) {
                if (!value && !this.isOk) {
                    this.moveX = 0
                    this.ms = '.2s'
                    this.$emit('end', 'no')
                } else {
                    this.ms = '0s'
                }
            }
        },
        isOk: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.$emit('end', 'ok')
                }
            }
        }
    },
};
</script>
<style>
.lee-slide-check {
  position: relative;
  background-color: #e8e8e8;
  text-align: center;
}

.lee-slide-check .slide-bg {
  height: 100%;
}

.lee-slide-check .slide-text {
  -webkit-user-select: none;
  width: 100%;
  height: 100%;
  position: absolute;
  text-align: center;
  top: 0px;
  left: 0;
}

.lee-slide-check .slide-text .b {
  color: #fff;
  font-style: normal
}


.lee-slide-check .handle {
  position: absolute;
  top: 0px;
  width: 20%;
  height: 100%;
  border: 1px solid #ccc;
  cursor: move;
  background: #fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==) no-repeat center;
}

.lee-slide-check .handle.ok {
  pointer-events: none;
  background: #fff url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==) no-repeat center;
}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeSlideCheck.vue